import { render, staticRenderFns } from "./ResponsibilitiesBlock.vue?vue&type=template&id=316c3d82"
import script from "./ResponsibilitiesBlock.vue?vue&type=script&lang=js"
export * from "./ResponsibilitiesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports